import { DriverHistory } from './driver-history.model';

export class DriverHistoryModel {
  StationID: string;
  StationName: string;
  TransactionId: string;
  PaginationCounter: string;
  DateTime: string;
  Durration: number;
  Consumption: number;
  PriceConsumption: number;
  PriceParkingTime: number;
  PriceUnit: string;
  PricePenalty: number;
  StationUserID: string;
  RealDateTime: Date;
  SignedTransaction: string;
  PublicKey: string;

  constructor(private driverHistory: DriverHistory) {
    this.StationID = driverHistory.stationId;
    this.StationName = driverHistory.stationName;

    this.Durration = driverHistory.duration;
    this.Consumption = driverHistory.consumption;
    this.PriceUnit = driverHistory.currencyCode;
    this.StationUserID = driverHistory.stationUserId;
    this.DateTime =
      driverHistory.startTime.toLocaleDateString() +
      ' ' +
      driverHistory.startTime.toLocaleTimeString();
    this.PriceConsumption = driverHistory.consumptionPrice;
    this.PriceParkingTime = driverHistory.parkingPrice;
    this.PricePenalty = driverHistory.penaltyPrice;
    this.RealDateTime = driverHistory.startTime;
    this.SignedTransaction = driverHistory.transaction;
    this.PublicKey = driverHistory.publicKey;
  }
}
